// Define all possible status values
export type StatusValue =
  | "To Do"
  | "In Progress"
  | "Done"
  | "Backlog"
  | "Sprint Planning"
  | "In Review"
  | "Code Review"
  | "Testing"
  | "Draft"
  | "Open"
  | "Changes Requested"
  | "Approved"
  | "Merged"
  | "Build"
  | "Test"
  | "Staging"
  | "Production";

// Status mapping for equivalent statuses
export const StatusEquivalents: Record<StatusValue, readonly string[]> = {
  "To Do": ["to do", "todo", "new", "open"],
  Open: ["open", "new", "created", "to do", "todo"],
  "In Progress": [
    "in progress",
    "active",
    "started",
    "in development",
    "implementing",
  ],
  Done: ["done", "completed", "finished", "closed", "resolved"],
  Backlog: ["backlog", "planned", "upcoming"],
  "Sprint Planning": ["sprint planning", "planning", "scheduled"],
  "In Review": ["in review", "reviewing", "under review"],
  "Code Review": ["code review", "peer review"],
  Testing: ["testing", "qa", "quality assurance", "verification"],
  Draft: ["draft", "wip", "work in progress"],
  "Changes Requested": [
    "changes requested",
    "needs changes",
    "revision needed",
  ],
  Approved: ["approved", "accepted", "ready"],
  Merged: ["merged", "integrated"],
  Build: ["build", "building"],
  Test: ["test", "testing"],
  Staging: ["staging", "pre-production"],
  Production: ["production", "live", "deployed"],
} as const;

// Common workflow templates
export const WorkflowTemplates = {
  SCRUM: [
    "Backlog",
    "Sprint Planning",
    "In Progress",
    "In Review",
    "Done",
  ] as StatusValue[],
  KANBAN: [
    "To Do",
    "In Progress",
    "Code Review",
    "Testing",
    "Done",
  ] as StatusValue[],
  PR_WORKFLOW: [
    "Draft",
    "Open",
    "In Review",
    "Changes Requested",
    "Approved",
    "Merged",
  ] as StatusValue[],
  DEPLOYMENT: ["Build", "Test", "Staging", "Production"] as StatusValue[],
  DEFAULT: ["Open", "In Progress", "Done"] as StatusValue[],
} as const;

export type WorkflowTemplate = keyof typeof WorkflowTemplates;

export interface Stage {
  name: string;
  status: "completed" | "current" | "pending";
  timestamp?: string;
  duration?: number;
  description?: string;
}

export interface StatusHistoryItem {
  status: string;
  oldStatus?: string;
  timestamp: string;
}
